import BaseModel from './BaseModel';

class Circle extends BaseModel {
  constructor(data = {}, useCase = 'update') {
    super(data);
    if(useCase === 'show'){
      this.showDetailsData(data);
    } else {
      this.updateData(data);
    }
  }

  showDetailsData = (data) => {
    this.id = data.id;
    this.name = data.name || "";
    this.address = data.address || "";
    this.pincode = data.pincode || "";
    this.zone = data.zone?.name || "";
    this.updated_at = data.updated_at || "";
    this.sap_code = data.sap_code?.code || "";
    this.prebooking_fee_refundable = data.prebooking_fee_refundable === true ? true : false;
    this.prebooking_fee = data.prebooking_fee || "";
  }

  updateData = (data) => {
    this.id = data.id;
    this.name = data.name || "";
    this.address = data.address || "";
    this.pincode = data.pincode || "";
    this.zone = data.zone;
    if(data.sap_code?.constructor === Object){
      this.sap_code = data.sap_code?.code || "";
      this.sap_code_id = data.sap_code?.id;
    } else {
      this.sap_code = data.sap_code || "";
      this.sap_code_id = data.sap_code_id || "";
    }
    this.prebooking_fee_refundable = data.prebooking_fee_refundable === true ? true : false;
    this.prebooking_fee = data.prebooking_fee || "";
  }

  toApiJson = () => {
    this.completeValidation();
    return {
      id: this.id,
      branch: {
        name: this.name,
        address: this.address,
        zone_id: this.zone?.id,
        sap_code_attributes: {
          id: this.sap_code_id || "",
          code: (this.sap_code).toUpperCase()
         },
        prebooking_fee_refundable: this.prebooking_fee_refundable,
        prebooking_fee: this.prebooking_fee,
        pincode: this.pincode,
      }
    }
  }

  validations = (field) => {
    return {
      name: () => {
        if (this[field].trim() === "") {
          this.errors.name = "This field is required.";
        } else if (this[field].search(/^[a-zA-Z\s'-]+$/) === -1) {
          this.errors.name = "Please enter a name using only letters.";
        } else {
          delete this.errors.name;
        }
      },
      address: () => {
        if (this[field].trim() === "") {
          this.errors.address = "This field is required.";
        } else {
          delete this.errors.address;
        }
      },
      sap_code: () => {
        if (!this[field] || this[field] === "") {
          this.errors.sap_code = "This field is required.";
        } else {
          delete this.errors.sap_code;
        }
      },
      prebooking_fee: () => {
        if(this.prebooking_fee_refundable === true){
          if ((this[field] < 0 || this[field] === "") || !this[field]) {
            this.errors.prebooking_fee = "This field is required and should be a positive number.";
          } else {
            delete this.errors.prebooking_fee;
          }
        } else {
          delete this.errors.prebooking_fee;
        }
      },
      pincode: () => {
        if (this[field].trim() === "") {
          this.errors.pincode = "This field is required.";
        } else if (this[field].search(/^\d{6}$/) === -1) {
          this.errors.pincode = "Invalid PIN code format.";
        } else {
          delete this.errors.pincode;
        }
      },
      zone: () => {
        if (!this[field] || Object.keys(this[field]).length === 0) {
          this.errors.zone = "Please select zone.";
        } else {
          delete this.errors.zone;
        }
      },
    }[field];
  }

  validate = (field) => {
    if (this.validations(field)) {
      this.validations(field)()
    }
  }
}

export default Circle;
